.root {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  min-width: min(1024px, 100%);
  margin-left: auto;
  margin-right: auto;
}

.headerControls {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  justify-content: space-between;
  align-items: center;
  transform: rotate(0);
  transition: opacity 195ms cubic-bezier(0.4, 0, 0.6, 1);
}

.headerLeft {
  justify-self: left;
}

.headerRight {
  justify-self: right;
}

/* Header controls stay quiet without fading: secondary text colour meets 4.5:1, where 50% opacity gave ~2.3:1 */
.quiet button:not(:disabled) {
  color: var(--tuna-content-secondary);
}

.quiet button:not(:disabled):hover,
.quiet button:focus-visible {
  color: var(--tuna-palette-primary-main);
}

.contentBox {
  flex: 1;
  flex-direction: column;
  display: flex;
  width: 100%;
  margin: auto;
  padding: 0 32px 0 32px;
  transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1);
}

@media (max-width: 599.95px) {
  .contentBox {
    padding: 0 8px;
  }
}
